import { createRoot } from "react-dom/client"
import { RouterProvider, createRouter } from "@tanstack/react-router"
import { QueryClientProvider } from "@tanstack/react-query"
import { routeTree } from "./routeTree.gen"
import { setAppRouter } from "./router-ref"
import { queryClient } from "./query-client"
import { installChunkReload } from "./chunk-reload"
import "./index.css"

installChunkReload()

const router = createRouter({
  routeTree,
  // Preload routes on link hover/focus — closest analogue to next/link's
  // viewport prefetch, and pairs with Query prefetching done in components.
  defaultPreload: "intent",
  // View Transitions: the browser keeps the old view painted and crossfades
  // into the new one — kills the blank flash on route swap (Next.js held the
  // old screen until the RSC payload arrived; this is the SPA equivalent).
  defaultViewTransition: true,
  // If a route still pends (cold chunk, slow loader), never paint a bare
  // blank: give it 1s before showing anything, then a quiet centered note.
  defaultPendingMs: 1000,
  defaultPendingMinMs: 400,
  defaultPendingComponent: () => (
    <div className="flex min-h-screen items-center justify-center text-muted-foreground">
      Đang tải…
    </div>
  ),
})
setAppRouter(router)

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <RouterProvider router={router} />
  </QueryClientProvider>,
)
